<table-list
    [resource]="clienteResource"
    [service]="clienteService"
></table-list>
